<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title class="center">Dettagli delle carte partner</h1>
<div mat-dialog-content>
    <div class="custcard-container">
        <div class="custcard-customer-profile">
            <div class="custcard-profile-banner"></div>
            <img
                class="custcard-profile-pic"
                src="assets/img/user.svg"
                alt="Customer Photo"
            />
            <div class="custcard-customer-name">{{ stripeCustomer?.name }}</div>
            <div class="custcard-customer-role">Partner</div>
            <div class="custcard-customer-contact">
                <i class="ml-10 fas fa-envelope"></i> {{ stripeCustomer?.email || "N/A" }}
                <br />
                <i class="ml-10 fas fa-phone"></i> {{ stripeCustomer?.phone }}
            </div>
        </div>

        <hr class="custcard-divider" />

        <div class="custcard-cards-grid" >
            <div class="custcard-card-item" [ngClass]="getDefaultCard(paymentMethod?.id) ? 'default-card' : ''" *ngFor="let paymentMethod of paymentMethods">
                <div class="custcard-card-header">
                    <img
                        [src]="getCardLogo(paymentMethod?.card?.display_brand)"
                        class="custcard-card-logo"
                        alt="Card Logo"
                    />
                    <div class="custcard-card-title">{{ paymentMethod?.card?.brand?.toUpperCase() }}</div>
                </div>
                <div class="custcard-card-data">
                    <span class="custcard-card-label">Numero della carta</span>
                    <span class="custcard-card-value">**** **** **** {{ paymentMethod?.card?.last4 }}</span>
                </div>
                <div class="custcard-card-data">
                    <span class="custcard-card-label">Scadenza</span>
                    <span class="custcard-card-value">{{ paymentMethod?.card?.exp_month }} / {{ paymentMethod?.card?.exp_year }}</span>
                </div>
                <div class="custcard-card-data">
                    <span class="custcard-card-label">CVV</span>
                    <span class="custcard-card-value">***</span>
                </div>
                <div *ngIf="!getDefaultCard(paymentMethod?.id) && (groups.includes('admin') || groups.includes('partner') || groups.includes('operation'))" class="custcard-card-actions">
                    <button class="custcard-card-btn" (click)="setDefaultCard(paymentMethod?.id)">Make Default</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>

</div>